import { RQ } from 'utils';
import { addClickAnalytics } from 'utils/analytics';

export default {
  getInfo: async function () {
    var self = this;
    if (this.enterpriseNo) {
      let d = await RQ.mall.get('/api/h5/coupon/listCoupon', { couponType: 2, roleType: 1 });
      if (d.code == 0 && d) {
        self.coupons = d.data.pageData;
        if (!d.data.summary || d.data.summary.receiveStatus == 1) {
          self.showCouponPopup = false;
        } else {
          self.showCouponPopup = true;
        }
      } else {
        self.tips(d.msg, 1500);
      }
    }
  },
  downLoadApp: async function () {
    if (this.enterpriseNo) {
      this.$router.push({ path: `/download?enterprise=${this.enterpriseNo}` });
    }
  },
  goToCouponCenter: async function () {
    addClickAnalytics({ LogTitle: '领优惠券' });
    if (this.enterpriseNo) {
      this.$router.push({ path: '/' + G.enterprise + '/coupons?inviteCode=' + this.inviteCode });
    }
  },
  receiveNewType: async function () {
    let self = this;
    let d = await RQ.mall.post('/api/h5/coupon/receiveByCouponType', { couponType: 2 });
    if (d.code == 0 && d) {
      self.tips(d.msg, 3000);
      self.showCouponPopup = false;
    } else {
      self.tips(d.msg, 1500);
    }
  },
  goShop() {
    // TODO 后退不能应对需求界面变化，需要修改更好的方法
    // this.$router.go(-2);
    this.$router.push(this.redirect);
    // this.$router.push({ path: '/goods?enterprise=' + this.enterpriseNo });
  }
};



// WEBPACK FOOTER //
// ./src/module/member/result/action.js